import React, { useEffect, useRef, useState } from 'react';

export interface AdvancedFiltersPanelProps {
  activeCount: number;
  children: React.ReactNode;
}

export const AdvancedFiltersPanel: React.FC<AdvancedFiltersPanelProps> = ({
  activeCount,
  children,
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    if (open) {
      document.addEventListener('mousedown', onOutside);
    }
    return () => document.removeEventListener('mousedown', onOutside);
  }, [open]);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="btn-surface-muted rounded-xl px-3 py-2 text-sm inline-flex items-center gap-2"
        aria-expanded={open}
        aria-haspopup="dialog"
      >
        Filters
        {activeCount > 0 ? (
          <span className="inline-flex min-w-[1.25rem] items-center justify-center rounded-full bg-primary px-1.5 py-0.5 text-[10px] font-semibold text-primary-fg">
            {activeCount}
          </span>
        ) : null}
      </button>
      {open ? (
        <>
          <div className="fixed inset-0 z-10 md:hidden" aria-hidden onClick={() => setOpen(false)} />
          <div
            role="dialog"
            aria-label="Advanced filters"
            className="absolute left-0 right-0 z-20 mt-2 rounded-xl border border-border bg-surface p-4 shadow-modern sm:left-auto sm:right-0 sm:w-[min(24rem,calc(100vw-2rem))]"
          >
            <div className="flex flex-col gap-3">{children}</div>
          </div>
        </>
      ) : null}
    </div>
  );
};

export default AdvancedFiltersPanel;
